import { render, staticRenderFns } from "./CustomerQuotes.vue?vue&type=template&id=bec519ee&scoped=true"
import script from "./CustomerQuotes.vue?vue&type=script&lang=js"
export * from "./CustomerQuotes.vue?vue&type=script&lang=js"
import style0 from "./CustomerQuotes.vue?vue&type=style&index=0&id=bec519ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec519ee",
  null
  
)

export default component.exports